import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ShareReferenceLocationState } from '$types/LocationState';
import {
  employerEmailLoginAuthAction,
  employerGoogleLoginAuthAction,
  employerLinkedInLoginAuthAction,
} from '../../../../store/legacy/auth/auth.actions';
import { LoginFormTypes } from '../../../../constants/FormTypes';
import { emailRegex } from '../../../../constants/regex';
import { useAppDispatch, useAppSelector } from '../../../../hooks';

const useLoginEmployerForm = () => {
  const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.auth);
  const { brandName } = useAppSelector((state) => state.brand);
  const [t, i18next] = useTranslation('global');
  const navigate = useNavigate();
  const location = useLocation() as ShareReferenceLocationState;
  const [searchParams] = useSearchParams();
  const shareCandidatesIds =
    location?.state?.shareCandidatesIds ||
    searchParams.get('shareCandidatesIds') ||
    undefined;

  useEffect(() => {
    if (authState.isLoggedIn) {
      if (shareCandidatesIds) {
        navigate(`/share/candidates/${shareCandidatesIds}`);
      } else {
        navigate(
          '/employer-dashboard/positions',
          location?.state && { state: { ...location.state } }
        );
      }
    }
  }, [authState, navigate, location?.state, shareCandidatesIds]);

  const onGoogleSignIn = () => {
    dispatch(employerGoogleLoginAuthAction(i18next.language));
  };
  const onLinkedInSignIn = () => {
    dispatch(employerLinkedInLoginAuthAction(i18next.language));
  };

  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm<LoginFormTypes>({ mode: 'onChange' });
  const email = register('email', {
    required: true,
    pattern: emailRegex,
    maxLength: {
      value: 100,
      message: t('register.invalidEmailInput').toString(),
    },
  });
  const password = register('password', { required: true });

  const submitForm = (values: LoginFormTypes) => {
    dispatch(
      employerEmailLoginAuthAction(
        values.email.toLowerCase(),
        values.password,
        i18next.language,
        brandName
      )
    );
  };

  return {
    onGoogleSignIn,
    onLinkedInSignIn,
    handleSubmit,
    submitForm,
    email,
    password,
    errors,
    isValid,
    t,
  };
};

export default useLoginEmployerForm;
